import { defineComponent as _defineComponent } from 'vue';
import { ref, watchEffect, onMounted, onBeforeUnmount } from 'vue';
import { useFrameStore } from './seg-frame-store';
import { TABS, FRAME_COLORS, ASSEMBLY_STEP_TYPES } from './helpers/frameConstants';
import { renderFrameToSvg } from './helpers/svgRenderer';
import HardwareLegend from "./HardwareLegend.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'VisualizerCanvas',
    setup(__props, { expose: __expose }) {
        __expose();
        const store = useFrameStore();
        const svgRef = ref(null);
        // ── ZOOM CONTROLS ────────────────────────────────────────────
        function applyZoom(factor) {
            store.viewport.zoom = Math.max(0.5, Math.min(8, store.viewport.zoom * factor));
        }
        function resetView() {
            store.viewport.zoom = 1;
            store.viewport.panX = 0;
            store.viewport.panY = 0;
        }
        function toggleExplode() {
            store.isExploded = !store.isExploded;
        }
        // ── KEYBOARD SHORTCUTS ───────────────────────────────────────
        function handleKeydown(e) {
            if (e.key === '=' || e.key === '+')
                applyZoom(1.2);
            else if (e.key === '-')
                applyZoom(1 / 1.2);
            else if (e.key === '0')
                resetView();
        }
        // ── TOUCH PINCH ZOOM ─────────────────────────────────────────
        let lastPinchDist = 0;
        function handleTouchStart(e) {
            if (e.touches.length === 2) {
                lastPinchDist = Math.hypot(e.touches[0].clientX - e.touches[1].clientX, e.touches[0].clientY - e.touches[1].clientY);
            }
        }
        function handleTouchMove(e) {
            if (e.touches.length === 2) {
                e.preventDefault();
                const d = Math.hypot(e.touches[0].clientX - e.touches[1].clientX, e.touches[0].clientY - e.touches[1].clientY);
                if (lastPinchDist > 0)
                    applyZoom(d / lastPinchDist);
                lastPinchDist = d;
            }
        }
        function handleTouchEnd() {
            lastPinchDist = 0;
        }
        onMounted(() => {
            window.addEventListener('keydown', handleKeydown);
        });
        onBeforeUnmount(() => {
            window.removeEventListener('keydown', handleKeydown);
        });
        // ── REACTIVE RENDER ──────────────────────────────────────────
        watchEffect(() => {
            const svg = svgRef.value;
            const data = store.activeFrameData;
            // Resolve the assembly step type for highlight state
            const stepType = store.activeTab === TABS.ASSEMBLY
                ? (store.assemblySteps[store.assemblyStep]?.type ?? ASSEMBLY_STEP_TYPES.ORGANIZE)
                : ASSEMBLY_STEP_TYPES.ORGANIZE;
            // Access all reactive dependencies before any early returns
            const isExploded = store.isExploded;
            const frameColor = store.activeFrame?.frameColor ?? FRAME_COLORS.SILVER;
            const viewport = store.viewport;
            const _tab = store.activeTab;
            if (!svg)
                return;
            if (!data) {
                while (svg.firstChild)
                    svg.removeChild(svg.firstChild);
                return;
            }
            renderFrameToSvg(svg, data, { isExploded, frameColor, viewport, stepType });
        }, { flush: 'post' });
        const __returned__ = { store, svgRef, applyZoom, resetView, toggleExplode, handleKeydown, get lastPinchDist() { return lastPinchDist; }, set lastPinchDist(v) { lastPinchDist = v; }, handleTouchStart, handleTouchMove, handleTouchEnd, HardwareLegend };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
